<template>
  <div class="d-flex flex-column pl-16">
    <div style="min-width: 100px; max-width: 100px"></div>
    <div class="flex d-flex justify-space-between">
      <div
      v-if="id === '63.1' || id === '63.6' || id === '69.1' || id === '69.6'"  class="pt-2" :class="labelTextClass" >
       {{ label }}
      </div>
      <div v-else class="pt-2">
        {{ label }}
        </div>

      <div class="d-flex justify-end gap-16">
        <div
            v-if="summary"
            class="pt-2 text-end"
            style="min-width: 150px; max-width: 150px"
        >
          {{ formatNumber(field) }}
        </div>
        <TextField
            v-else
            theme="3"
            input-type="decimal"
            :value="field"
            isFormat
            :readonly="readonly"
            @onChange="eventChange"
            @onFocusOut="eventFocusOut"
            :disabled="disabled"
        ></TextField>

        <div class="pt-2" style="min-width: 130px">
          {{ unit }}
        </div>
      </div>
    </div>
    <div class="flex">
      <TextArea
          v-if="desc_flag"
          theme="3"
          height="150px"
          :label="desc_label"
          :value="desc_value"
          @onChange="onDescChange"
          :disabled="disabled"
      ></TextArea>
    </div>
  </div>
</template>

<script>
import TextField from "./input/TextField"
import { formatNumber } from "../plugins/global-funcs"
import TextArea from "@/components/input/TextArea";

export default {
  name: "OOILineField",
  components: {
    TextArea,
    TextField
  },
  props: {
    id: {
      default: null
    },
    url: {
      default: null
    },
    field: {
      default: ''
    },
    label: {
      default: ''
    },
    readonly: {
      default: false
    },
    unit: {
      default: 'ราย'
    },
    summary: {
      default: false
    },
    desc_flag: {
      default: 0
    },
    desc_label: {
      default: null
    },
    desc_value: {
      default: null
    },
    disabled: {
      default: false
    },
    labelTextClass: {
      default: 'black--text'
    }
  },
  data () {
    return {
      formatNumber
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    },
    onDescChange (val) {
      this.$emit('onDescChange', val)
    },
    eventFocusOut () {
      this.$emit('onFocusOut')
    },
    hrefTo () {
      window.open(this.url, "_blank");
      // console.log(this.url);
    }
  }
}
</script>

<style scoped>
.h-15 {
  height: 60px;
}
</style>